import React from 'react';

import { Divider } from '@material-ui/core';

import { Collapsible, FormFieldWrapper, SortableList } from '../Global';
import { Panel } from '.';

import makePath from '../../utils/makePath';


export const Column = React.memo((props) => {
  
  const path = makePath(props.path, props.index)

  return (
    <Collapsible  headerTag="h5" title={`Column ${props.index + 1}`} sortableChild grayTheme>
      <FormFieldWrapper></FormFieldWrapper>
      <SortableList
        label="Panel"
        name='panels'
        min={1}
        max={2}
        path={path}
        given={props.given ? props.given.panels : null}
      >
        <Panel />
      </SortableList>

      <Divider style={{marginBottom: 0}} />

      {props.deleteBtn}
    </Collapsible>
  )
})